import React from 'react';
import classnames from 'classnames';
import { default as pluralize } from 'pluralize';
import { commonEnums, objectUtils } from '@codametrix/ui-common';

const { EditorIssueProvenance, EditorIssueLevel } = commonEnums;

const formatMessage = (messageType: string, idx: number) => (
  edit: CMxCommonApp.EditorIssue
) => {
  return (
    <li key={`${edit.message}-${idx}`}>
      <span>{edit.message}</span>
    </li>
  );
};

const formatEditGroup = (rawEdits: CMxCommonApp.EditorIssue[], idx: number) => {
  // Messages are grouped by two properties.
  // 1. the source of the messages : CCI or Claims
  // 2. the status level : Warning or Error
  // We first sort the messages by source, and then by level.
  const sourceGroups = objectUtils.groupBy(rawEdits, 'source');
  return Object.values(sourceGroups).map((edits, subIdx) => {
    const levelGroups = objectUtils.groupBy(edits, 'level');
    return (Object.values(levelGroups) as CMxCommonApp.EditorIssue[][]).map((levelGroup, sectionIdx) => {
      const [edit] = levelGroup;
      const editLevel = (edit?.level ?? 'unknown').toLowerCase();
      const heading = getMessageHeading(levelGroup);
      const formatEdit = formatMessage(editLevel, subIdx);
      let editMessages = levelGroup.map(formatEdit);

      const styleClasses = classnames(`${editLevel}-msg`);

      return (
        <div className="messages" key={`${idx}-${subIdx}-${sectionIdx}`}>
          {heading}
          <ul className={styleClasses}>{editMessages}</ul>
        </div>
      );
    });
  });
};

const formatMessages = (...issueGroups: CMxCommonApp.EditorIssue[][]) => {
  if (!issueGroups || !issueGroups.length) {
    return false;
  }

  return issueGroups.map(formatEditGroup).flat() ?? false;
};

const getMessageHeading = (edits: CMxCommonApp.EditorIssue[]) => {
  const [edit] = edits;
  const errorType = objectUtils.capitalize(`${edit.level}`);
  const source =
    edit.source !== EditorIssueProvenance.CCI
      ? objectUtils.capitalize(`${edit.source}`)
      : edit.source;
  return (
    <h5 className="message-type-heading qa-scrubber-message-heading">
      {source} {pluralize(errorType, edits.length)}
    </h5>
  );
};

export { formatMessages, formatEditGroup, getMessageHeading };
